import React, { Component } from 'react';
import { withStyles } from 'material-ui';
import SeatSelectionMobileContainerStyles from './SeatSelectionMobileContainerStyles';
import SeatSelectionMobileContainerProps from './SeatSelectionMobileContainerProps';
// import Constants from '../../../../model/AppConfiguration';
import SeatSelectionHeader from '../common/seatSelection/SeatSelectionHeader';
import SeatSelection from '../common/seatSelection/SeatSelection';

/**
 * ## Redux imports
 */
import * as passengerActions from '../../../redux/actions/PassengerActions';
import * as globalActions from '../../../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../redux/selectors/Index';
import RouteTabs from '../../routeTabs/RouteTabs';
import SeatsLegend from '../../../components/seats/seatsLegend/SeatsLegend';
import SeatsInfo from '../../../components/seats/seatsInfo/SeatsInfo';
import Dictionary from '../../../model/Dictionary';
import PassengerNavigator from '../../../components/seats/passengerNavigator/PassengerNavigator';
import SeatsScreenController from '../SeatsScreenController';

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions, passengerActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    flights: selectors.flights.getFlights(state.flights),
    passengers: selectors.passengers.getPassengers(state.passengers),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class SeatSelectionMobileContainer extends Component {
  static propTypes = SeatSelectionMobileContainerProps;

  constructor (props) {
    super(props);

    this.state = this.getSelectedPassenger(props);
    this.changePassenger = SeatsScreenController.changePassenger.bind(this);
  }

  componentWillReceiveProps (props) {
    this.setState(this.getSelectedPassenger(props));
  }

  getSelectedPassenger (props) {
    const { selectedRoute, flights, selectedPassenger } = props;
    let passengers = [];
    if (selectedRoute && selectedRoute.id) {
      let flight = selectors.flights.getFlightByRouteId(flights, selectedRoute.id);
      passengers = flight.passengers;
    }
    if (selectedPassenger) {
      let flightPassenger = selectors.passengers.getPassengerById(passengers, selectedPassenger);
      let passenger = selectors.passengers.getPassengerById(props.passengers, selectedPassenger);
      return { passengers, passenger: Object.assign({}, passenger, flightPassenger) };
    }
    return { passengers, passenger: {} };
  }

  navigateThroughtPassengers = operation => {
    let newActivePassenger = this.changePassenger(
      this.state.passengers,
      this.props.selectedPassenger,
      operation
    );
    this.props.actions.changeActivePassenger(newActivePassenger);
  };

  render () {
    const {
      classes,
      handleClose,
      routes,
      centered,
      showDate,
      selectedTrip,
      selectedRoute,
      toggleRoutes,
      selectedPassenger,
    } = this.props;

    return (
      <div className={classes.backgroundWrapper}>
        <form className={classes.container} noValidate autoComplete='off'>
          <SeatSelectionHeader handleClose={handleClose} title={Dictionary.seat.select} />

          <PassengerNavigator
            passenger={this.state.passenger}
            passengerNavigation={this.navigateThroughtPassengers}
          />

          <RouteTabs
            centered={centered}
            showDate={showDate}
            routes={routes}
            selectedTrip={selectedTrip}
            selectedRoute={selectedRoute}
            toggleRoutes={toggleRoutes}
            TabContent={
              <div>
                <SeatsLegend />
                <SeatsInfo />
                <SeatSelection
                  selectedPassenger={selectedPassenger}
                  routeId={selectedRoute ? selectedRoute.id : ''}
                />
              </div>
            }
          />
        </form>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(SeatSelectionMobileContainerStyles)(SeatSelectionMobileContainer)
);



// WEBPACK FOOTER //
// ./src/containers/seats/mobile/SeatSelectionMobileContainer.js